const state = {
  runTopMedia: false,
  runVideo: false,
  viewMap: false
};

// Suggest use getters instead of state
const getters = {
  getRunTopMedia (state) {
    return state.runTopMedia;
  },
  getRunVideo (state) {
    return state.runVideo;
  },
  getViewMap (state) {
    return state.viewMap;
  }
};

const mutations = {
  setRunTopMedia (state) {
    state.runTopMedia = true;
  },
  setRunVideo (state) {
    state.runVideo = true;
  },
  setViewMap (state) {
    state.viewMap = true;
  }
};

const actions = {
  runTopMedia ({commit}) {
    commit('setRunTopMedia');
  },
  runVideo ({commit}) {
    commit('setRunVideo');
  },
  runViewMap ({commit}) {
    commit('setViewMap');
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
